export default __webpack_public_path__ + "static/media/8.c83e0a74.jpg";